import React, { Fragment, Suspense } from "react";
import { SVCURL } from "@data/GlobalData.js";
import { useGenerateStateListEntry } from "@apicontrols/useGenerateStateListEntry.js";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import { PROCESS_SELECTMESSAGECOUNT } from "@genericComponents/CFW.js";
import { Clone } from "@genericComponents/Common.js";
import Loading from "@genericComponents/Loading.js";
import { MaintainMessage } from "@genericComponents/PFW.js";
import { User } from "@genericComponents/User.js";
const RetrieveComponent = ({ list }) => {
  const data = useGenericStore(list.state, list.defaultData());
  return Array.isArray(data) && data?.length ? (
    <div className="counter">{data[0]?.MessageCount}</div>
  ) : (
    <Fragment />
  );
};
const MessageCount = () => {
  const Response_MessagesCount = "MessagesCount";
  const param = Clone(MaintainMessage);
  param.Process = PROCESS_SELECTMESSAGECOUNT;
  const { list } = useGenerateStateListEntry(
    Response_MessagesCount,
    [SVCURL, "MaintainMessage"].join(""),
    param,
    User.UserGUID(),
    MaintainMessage,
  );
  return User.AccessToken() && User.IsLoggedIn() ? (
    <Suspense fallback={<Loading />}>
      <RetrieveComponent list={list} />
    </Suspense>
  ) : (
    <Fragment />
  );
};
export default MessageCount;
